<section class="section breadcrumbs-custom" *ngIf="content">

    <div class="breadcrumbs-custom-main bg-image bg-primary">
    </div>

    <div class="breadcrumbs-custom-aside">
        <div class="container">
            <ul class="breadcrumbs-custom-path">
                <li><a routerLink="/home">Αρχική</a></li>
                <li><a routerLink="/job-listing">Θέσεις Εργασίας</a></li>
                <li *ngIf="content.title && content.title.length>30" placement="top-left" ngbTooltip={{content.title}}>{{content.title.substr(0, 30)}}...</li>
                <li *ngIf="content.title && content.title.length<=30" class="active">{{content.title}}</li>
            </ul>
        </div>
    </div>
</section>

<section class="section section-md-changed" *ngIf="content">
    <div class="container">

        <app-alert-message *ngIf="authService.isCandidate() && userInfo && userInfo.status==='pending'" [alertOption]="1"></app-alert-message>
        <app-alert-message *ngIf="authService.isCandidate() && userInfo && userInfo.status==='disapproved'" [alertOption]="2"></app-alert-message>

        <div id="col-reverse-1" class="row">
            <app-alert-message style="width: 100%" *ngIf="alert" [alertOption]="alert"></app-alert-message>

            <div class="col-lg-8 col-md-12 col-xs-12 col-sm-12">

                <div class="row">
                    <div class="col-lg-12 col-md-12 col-xs-12 col-sm-12">
                        <div class="layout-details">
                            <h3 style="margin-bottom: 10px" id="title">{{content.title}}</h3>

                            <div class="row row-15 row-bordered">

                                <div class="col-sm-12 col-12 col-md-3 col-lg-3 ">
                                     <img *ngIf="content.logo" class="img-thumbnail company-logo" src="{{content.logo}}" alt="" /> 
                                    <img *ngIf="!content.logo" class="img-thumbnail company-logo" src="assets/images/defaultcompanylogo.jpg" alt="" />
                                </div>

                                <div class="col-sm-12 col-12 col-md-4 col-lg-4 vertical-line">
                                    <ul class="list list-xs">
                                        <li>
                                            <a [routerLink]="['/employer/profile', content.companyId]">
                                                <p><span class="icon icon-sm text-primary mdi mdi-city"></span>
                                                    <span class="context-break" placement="top-left" ngbTooltip="Προφίλ εταιρείας">
                                                    {{content.companyName}}</span>
                                                </p>
                                            </a>
                                        </li>

                                        <li>
                                            <p *ngIf="content.locationName"><span class="icon text-primary mdi mdi-map-marker"></span><span class="context-break"> {{content.locationName}}</span>
                                            </p>
                                        </li>

                                        <li>
                                            <p><span class="icon text-primary mdi mdi-web"></span><span><a class="context-break"
                                                            href="mailto:{{content.email}}"> {{content.email}}</a></span>
                                            </p>
                                        </li>
                                    </ul>
                                </div>

                                <div class="col-sm-12 col-12 col-md-5 col-lg-5">
                                    <ul class="list list-xs">
                                        <li>
                                            <p class=""><span class="icon text-primary mdi mdi-clock"></span><span> Ημ/νία
                                                        ανάρτησης: {{content.creation_date|date: 'mediumDate'}}</span>
                                            </p>
                                        </li>
                                        <li *ngIf="content.expirationDate">
                                            <p class=""><span class="icon text-primary mdi mdi-calendar-clock"></span><span> Ημ/νία
                                                        λήξης: {{content.expirationDate|date: 'mediumDate'}}</span>
                                            </p>
                                        </li>
                                        <li *ngIf="!content.expirationDate">
                                            <p class=""><span class="icon icon-default text-primary mdi mdi-calendar-clock"></span><span> Ημ/νία
                                                        λήξης: -</span>
                                            </p>
                                        </li>
                                        <li>
                                            <p *ngIf="content.salary" class=""><span class="icon icon-sm text-primary mdi mdi-cash"></span>
                                                <span> Μισθός:
                                                        {{content.salary | currency:'EUR':true}}
                                                    </span>
                                            </p>
                                        </li>
                                        <li>
                                            <p *ngIf="isSigned && !authService.isCandidate() && content.companyId===currentUserUUid" (click)="appliedCandidatesList()" class="object-inline object-inline_sm" style="cursor: pointer;"><span class="icon icon-default text-primary mdi mdi-file-document"></span><span placement="top-left" ngbTooltip="Δες τις αιτήσεις">{{content.applications}} αιτήσεις</span>
                                            </p>
                                            <p *ngIf="content.companyId!==currentUserUUid" class="object-inline object-inline_sm"><span class="icon icon-default text-primary mdi mdi-file-document"></span><span>{{content.applications}} αιτήσεις</span>
                                            </p>
                                        </li>

                                    </ul>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <p id="descriptionParagraph" class="text-style-1" [innerHtml]="content.description | safe"></p>
                <div class="row row-30">
                    <div class="col-md-6">
                        <h4>Απαιτούμενα προσόντα</h4>
                        <div *ngIf="content.prerequisites" class="listDiv" [innerHtml]="content.prerequisites | safe">

                        </div>
                        <div *ngIf="!content.prerequisites">
                            <p>Δεν έχουν εισαχθεί απαιτούμενα προσόντα</p>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <h4>Προσφέρονται</h4>
                        <div class="listDiv" *ngIf="content.benefits" [innerHtml]="content.benefits | safe">

                        </div>
                        <div *ngIf="!content.benefits">
                            <p>Δεν έχουν εισαχθεί παροχές</p>
                        </div>
                    </div>
                </div>

                <br />

                <!-- related jobs table -->
                <div *ngIf="relatedJobs && relatedJobs.length>0" class="block offset-top-2">
                    <h4> Σχετικές θέσεις εργασίας</h4>
                    <br />
                    <div *ngIf="metadata$ | async as metadata">
                        <table class="table-job-listing">
                            <tr ngDefaultControl [attr.data-item-value]="relatedJobs.title" *ngFor="let relatedJob of relatedJobs" (click)="jobDetails(relatedJob.uuid)">

                                <td>
                                    <article>
                                        <div>
                                            <h5 class="userSelect">
                                                <a placement="top-left" ngbTooltip={{relatedJob.title}}> {{relatedJob.title}}</a>
                                            </h5>
                                            <p *ngIf="relatedJob.locationName"><span style="color:grey;" class="icon icon-1 text-primary mdi mdi-map-marker"></span>{{relatedJob.locationName}} </p>
                                            <p *ngIf="!relatedJob.locationName"> - </p>
                                        </div>
                                    </article>
                                </td>
                                <!-- style for employment type label -->
                                <td *ngIf="relatedJob.employmentTypesName=='Πρακτική Άσκηση'" class="td-context-align">
                                    <span class="badge badge-context">{{relatedJob.employmentTypesName}}</span></td>
                                <td *ngIf="relatedJob.employmentTypesName=='Συμβασιούχος'" class="td-context-align">
                                    <span class="badge badge-secondary">{{relatedJob.employmentTypesName}}</span></td>
                                <td *ngIf="relatedJob.employmentTypesName=='Ελεύθερος επαγγελματίας'" class="td-context-align">
                                    <span class="badge badge-tertiary badge-context">{{relatedJob.employmentTypesName}}</span></td>
                                <td *ngIf="relatedJob.employmentTypesName=='Ασκούμενος'" class="td-context-align">
                                    <span class="badge badge-tertiary badge-context">{{relatedJob.employmentTypesName}}</span></td>
                                <td *ngIf="relatedJob.employmentTypesName=='Μερική Απασχόληση'" class="td-context-align">
                                    <span class="badge badge-blue-11 badge-context">{{relatedJob.employmentTypesName}}</span></td>
                                <td *ngIf="relatedJob.employmentTypesName=='Πλήρης Απασχόληση'" class="td-context-align">
                                    <span class="badge badge-yellow-12 badge-context">{{relatedJob.employmentTypesName}}</span></td>
                                <td *ngIf="relatedJob.employmentTypesName=='Εποχική/Προσωρινή απασχόληση'" class="td-context-align">
                                    <span class="badge badge-season badge-context">{{relatedJob.employmentTypesName}}</span></td>
                                <td *ngIf="relatedJob.employmentTypesName=='Μη διαθέσιμο'" class="td-context-align">
                                    <span class="badge badge-undefined badge-context"></span></td>
                            </tr>
                        </table>
                    </div>
                    <br />
                    <!-- Pagination -->
                    <app-pagination-bs *ngIf="relatedPostJobs" [pageSize]="pageSize" [items]="relatedPostJobs" (changePage)="onChangePage($event)"></app-pagination-bs>
                </div>
            </div>

            <!-- delete/edit/post job posting button  -->
            <div id="col-reverse-2" *ngIf="isSigned && !authService.isCandidate() && content.companyId===currentUserUUid" class="col-lg-4 col-md-12 col-xs-12 col-sm-12 form-corporate">
                <div class="row">
                    <div class="col-md-12 col-lg-12">
                        <form class="rd-mailform form-spacing-small form-corporate form-margin" data-form-output="form-output-global" data-form-type="contact" method="post" action="bat/rd-mailform.php">

                            <div *ngIf="content.status==='closed'" class="row">
                                <button style="width: 100%; cursor: default; color:#ca5217" class="button context-break">Η αναρτηση
                                    αποσυρθηκε</button>
                            </div>

                            <div *ngIf="content.status!=='closed'" class="row">
                                <button class="button button-block button-edit context-break" (click)="editPost()" type="submit">Επεξεργασια αναρτησης
                                </button>
                            </div>
                            <div *ngIf="content.status==='published'" class="row">
                                <button class="button button-block button-edit context-break" (click)="openModal('closed')" type="submit">αποσυρση αγγελιας
                                </button>
                            </div>
                            <div *ngIf="content.status==='draft'" class="row">
                                <button class="button button-block button-edit context-break" (click)="openModal('published')" type="submit">Δημοσιευση
                                    Αναρτησης</button>
                            </div>
                            <div *ngIf="content.status==='closed'" class="row">
                                <button class="button button-block button-edit context-break" (click)="openModal('published')" type="submit">Αναδημοσιευση
                                </button>
                            </div>
                            <div *ngIf="content.status==='draft' || (content.status==='closed' && content.applications===0)" class="row">
                                <button class="button button-block button-delete context-break" (click)="openModal('delete')" type="submit">Διαγραφη
                                </button>
                            </div>
                            <br />
                        </form>
                    </div>
                </div>
            </div>

            <!-- apply button -->
            <div class="col-lg-4" *ngIf="hasApplied!==undefined">
                <div class="row">
                    <div *ngIf="isSigned && authService.isCandidate() && !hasApplied" class="col-md-6 col-lg-12 ">
                        <form class="rd-mailform form-corporate form-spacing-small form-margin" data-form-output="form-output-global" data-form-type="contact" method="post" action="bat/rd-mailform.php">
                            <div class="row">
                                <button *ngIf="authService.isValidCandidate && userInfo.status==='approved'" class="button button-block button-primary context-break" data-toggle="modal" data-target="#applyModal">Kανε Αιτηση</button>

                                <button *ngIf="!authService.isValidCandidate && userInfo.status==='approved'" class="button button-block button-primary context-break" data-toggle="modal" data-target="#notValidCanditateModal">Kανε Αιτηση</button>

                                <button *ngIf="authService.isCandidate() && (userInfo.status==='disapproved'|| userInfo.status==='pending')" class="button button-block button-disabled context-break" data-toggle="modal" data-target="#notValidCanditateModal" disabled>Kανε Αιτηση</button>
                            </div>
                        </form>
                        <img class="bg-image-10" src="assets/images/parallax-3.jpg">
                    </div>

                    <div *ngIf="isSigned && authService.isCandidate() && hasApplied" class="col-md-6 col-lg-12">
                        <form class="rd-mailform form-corporate form-spacing-small form-margin" data-form-output="form-output-global" data-form-type="contact" method="post" action="bat/rd-mailform.php">
                            <div class="row">
                                <button style="width: 100%; cursor: default; color:#0aa588e3" class="button context-break">εχετε κανει
                                    αιτηση</button>
                                <p style="width: 100%;text-align:center"> Ημ/νία αίτησης: {{candidateApplication.creationDate|date: 'mediumDate'}} </p>
                            </div>
                        </form>
                        <img class="bg-image-10" src="assets/images/parallax-3.jpg">
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- apply Modal -->
<div class="modal fade" id="applyModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true" *ngIf="userInfo">
    <form (ngSubmit)="onApply(applyForm)" #applyForm="ngForm">
        <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
            <div class="modal-content" id="modalContent">
                <div id="modalHeader" class="modal-header">
                    <h5 class="modal-title" id="modalTitle">Κάνε Αίτηση</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body modalBody">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-wrap">
                                            <label class="form-label-outside">Όνομα</label>
                                            <div class="form-wrap-inner">
                                                <input [value]=this.userInfo.firstName class="form-input disabledInput modalNames" type="text" data-constraints="@Required" disabled="true">
                                                <input type="hidden" ngModel name="name" [(ngModel)]=this.userInfo.firstName>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-wrap">
                                            <label class="form-label-outside">Επώνυμο</label>
                                            <div class="form-wrap-inner">
                                                <input [value]=this.userInfo.lastName placeholder="Πληκτρολόγησε το Eπώνυμό σου" class="form-input disabledInput modalNames" type="text" data-constraints="@Required" disabled="true">
                                                <input type="hidden" ngModel name="surname" [(ngModel)]="userInfo.lastName" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-wrap">
                                            <label class="form-label-outside">Ηλεκτρονικό
                                                Ταχυδρομείο</label>
                                            <div class="form-wrap-inner">
                                                <input disabled="true" [value]="this.userInfo.email" class="form-input modalNames" placeholder="πχ. test@email.gr" id="rd-navbar-register-email" type="email" data-constraints="@Email @Required" />
                                                <input id="email" type="hidden" [(ngModel)]="userInfo.email" name="email" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-wrap">
                                            <label class="form-label-outside" for="general-information-name">Cover
                                                Letter</label>
                                            <div class="form-wrap-inner">
                                                <textarea ngModel id="textArea" placeholder="" class="form-input mytextArea" id="general-information-name" type="text" name="description" data-constraints="@Required"></textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <!-- buttons for cv -->

                        <div *ngIf="!userInfo.cv_id" class="row">
                            <div class="col-xl-3 col-lg-6">
                                <label id="cvBtn" class="button button-sm button-primary button-icon button-icon-left">
                                    <input type="file" name="resume-file" form="submit-resume-form"
                                        accept=".pdf,.doc,.docx" (change)="handleCVInput($event.target.files)"> <span
                                        class="icon mdi mdi-attachment"
                                        style="transform: rotate(270deg); transform-origin: 37% 27%;"></span>Προσθεσε
                                    βιογραφικο
                                </label>
                                <span id="cv_id"></span>
                                <div *ngIf="cvMessage" class="text-danger">
                                    {{ cvMessage }}
                                </div>
                            </div>
                        </div>

                        <div *ngIf="userInfo.cv_id && cvForTheJob" class="row">
                            <div class="col-xl-3 col-lg-6">

                                <div class="form-wrap">
                                    <label style="font-size: 16px;" class="form-label-outside"> Το βιογραφικό μου
                                    </label>
                                    <div class="form-wrap-inner">
                                        <a *ngIf="userInfo.cv_id===cvForTheJob" [href]="fileUrl" (click)="downLoadCv(userInfo.keycloakId)">{{cvForTheJob}}</a>
                                        <p *ngIf="userInfo.cv_id!=cvForTheJob">{{cvForTheJob}}</p>
                                        <hr>
                                        <label id="cvBtn" class="button button-sm button-primary button-icon button-icon-left">
                                            <input type="file" name="resume-file" form="submit-resume-form"
                                                accept=".pdf,.doc,.docx"
                                                (change)="handleCVInput($event.target.files)"><span
                                                class="icon mdi mdi-attachment"
                                                style="transform: rotate(270deg); transform-origin: 37% 27%;"></span>
                                            αλλαγη βιογραφικου
                                        </label>
                                        <div *ngIf="cvMessage" class="text-danger">
                                            {{ cvMessage }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="modal-footer">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="offset-xl-6 col-xl-3 offset-lg-0 col-lg-6 col-sm-6 offset-sm-0">
                                <button class="myBtns button button-primary float-right" type="submit ">Αποστολη</button>
                            </div>
                            <div class="col-xl-3 col-xl-auto col-lg-6 col-lg-6 col-sm-6">
                                <button class=" myBtns button button-secondary float-right" data-dismiss="modal">Ακυρωση</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>

<!-- confirm Modal -->
<app-confirm-modal [bodyMessage]="confirmModalbody" [titleMessage]="confirmModaltitle" (confirm)="onConfirmModal()"></app-confirm-modal>
<!-- not valid candidate Modal -->
<div class="modal fade" id="notValidCanditateModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Αδυναμία ολοκλήρωσης αίτηματος</h5>

                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <h5 class="modal-title" id="exampleModalLabel"></h5>
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                Για να έχετε τη δυνατότητα να κάνετε αίτηση θα πρέπει πρώτα να ολοκληρώσετετ το προφίλ σας
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-cancel" data-dismiss="modal">Ακύρωση</button>
                <button type="button" (click)="navigateToCompleteProfile()" class="btn btn-primary">Ολοκληρωση Προφιλ</button>
            </div>
        </div>
    </div>
</div>